import { render, staticRenderFns } from "./TrueFalse.vue?vue&type=template&id=1e0e3738"
import script from "./TrueFalse.vue?vue&type=script&lang=js"
export * from "./TrueFalse.vue?vue&type=script&lang=js"
import style0 from "./TrueFalse.vue?vue&type=style&index=0&id=1e0e3738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports